import { Component, OnInit, ViewChild, ElementRef, Renderer } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { trigger, state, animate, transition, style } from '@angular/animations';

import Utils from '../shared/utility';
import { GlobalService } from '../services/global.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { AdvisorBarService } from '../shared/advisor-bar/advisor-bar.service';
import { LoadingService } from '../shared/loading/loading.service';

import { PagerService } from '../services/pager.service';

@Component({
  selector: 'app-create-report-selection',
  templateUrl: './create-report-selection.component.html',
  styleUrls: ['./create-report-selection.component.css']
})
export class CreateReportSelectionComponent implements OnInit {
  public clients: any[];
  public filteredClients: any[];
  public selectedClient: any = {};
  public reports: any[] = [];

  public error: string;

  public modalSubscription;
  public loadingSubscription;
  public previousUrl: string;

  public pager: any = {};
  public pagedItems: any[];

  constructor(private advisorBarService: AdvisorBarService, private globalService: GlobalService, private modalService: ModalService,  private pagerService: PagerService, private router: Router, private snackBarService: SnackBarService, private loadingService: LoadingService, private route: ActivatedRoute) {
    this.getClients();

    this.modalSubscription = modalService.modal$.subscribe((modal) => {
      if (modal.modalName == 'add-edit-clientClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
        this.getClient(localStorage.getItem('selectedClient'));
      }
    });
  }


  public isOA: boolean;
  public isS: boolean;
  public isA: boolean;
  public isHVS: boolean;
  
  public riskToleranceEnabled: boolean;

  ngOnDestroy() {
    this.modalSubscription.unsubscribe();
  }

  public role: Number;

  ngOnInit() {
    this.role = Number(localStorage.getItem('roleId'));
    this.isOA = (Number(localStorage.getItem('orgID')) === 2 || Number(localStorage.getItem('parentID')) === 2) ? true : false;
    this.isS = (Number(localStorage.getItem('orgID')) === 371 || Number(localStorage.getItem('parentID')) === 371) ? true : false;
    this.isA = (Number(localStorage.getItem('orgID')) === 421 || Number(localStorage.getItem('parentID')) === 421) ? true : false;
    this.isHVS = Number(localStorage.getItem('orgID')) === 1 ? true : false;
    this.dropDownReportTypeShowHide();

    if (localStorage.getItem('selectedClient')) {
      this.getClient(Number(localStorage.getItem('selectedClient')));
      this.getClientReports(Number(localStorage.getItem('selectedClient')));
    }

    this.dropDownReportTypeShowHide();
  }

  dropDownReportTypeShowHide() {
    this.globalService.featRiskTolerance = JSON.parse(localStorage.getItem('featRiskTolerance'));
    this.globalService.featMeansTesting = JSON.parse(localStorage.getItem('featMeansTesting'));
    this.globalService.featLongTermCare = JSON.parse(localStorage.getItem('featLongTermCare'));
    this.globalService.featSocialSecurity = JSON.parse(localStorage.getItem('featSocialSecurity'));
    this.globalService.featHealthCare = JSON.parse(localStorage.getItem('featHealthCare'));
  }

  getClients() {
    if (window.location.search.split('?')[1] != 'd=t')
      this.loadingService.isLoading(true);

    var spouses;

    this.globalService.getClientsData()
      .subscribe(
      clients => {
        this.clients = clients.map((item) => {
          if (item.c) {
            spouses = JSON.parse(item.cp.Spouses) || [];

            spouses.map((spouse) => {
              if (spouse.maritalStatus == 'Married') {
                item.c.spouseName = spouse.firstName + " " + spouse.lastName;
              }
            });

            return item.c;
          } else {
            return item;
          }
        });

        if (window.location.search.split('?')[1] != 'd=t')
          this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error;
        
        if (window.location.search.split('?')[1] != 'd=t')
          this.loadingService.isLoading(false);
      });
  }

  getClientReports(userID: number) {

    this.globalService.getClientReportsData(userID)
      .subscribe(
      reports => {
        var allReports = [];

        for (var type in reports) {
          reports[type].forEach((report) => {
            allReports.push({
              reportID: report.r.ReportID,
              ID: report.r.ID,
              reportTypeID: report.r.ReportTypeID,
              createdDate: report.r.Created_Date,
              advisorID: report.r.AdvisorID,
            });
          });
        }

        allReports = allReports.sort(function(a, b) {
          return b.ID - a.ID;
        });

        this.reports = allReports;
        this.setPage(allReports.length ? 1 : 0);
      },
      error => this.error = <any>error);
  }

  filterItem(value) {
    this.filteredClients = Object.assign([], this.clients).filter(
      client => ((client.FirstName + " " + client.LastName + " " + client.spouseName).toLowerCase().includes(value.toLowerCase()))
    );
  }

  isClientMarried: boolean = false;
  getClient(userID) {
    this.isClientMarried = false;
    this.globalService.getClientData(userID, 4)
      .subscribe(
      client => {
        this.selectedClient = client;
        this.selectedClient.clientProfile.CurrentIncome = Utils.formatToCurrency(this.selectedClient.clientProfile.CurrentIncome);
        this.selectedClient.clientProfile.Pension = Utils.formatToCurrency(this.selectedClient.clientProfile.Pension);

        var spouses = JSON.parse(this.selectedClient.clientProfile.Spouses) || [];
        spouses.map((spouse) => {
          if (spouse.maritalStatus == 'Married') {
            this.isClientMarried = true;
            this.selectedClient.client.spouseName = spouse.firstName + " " + spouse.lastName;
            this.selectedClient.client.spouseDOB = spouse.dob;
            this.selectedClient.clientProfile.spouseRetirementAge = spouse.retirementAge;
            this.selectedClient.clientProfile.spouseCurrentIncome  = Utils.formatToCurrency(spouse.currentIncome);
            this.selectedClient.clientProfile.spousePension = Utils.formatToCurrency(spouse.pension);
            if (this.selectedClient.clientProfile.spousePension.includes('$$')) { 
              //if has two, handle; this is an issue with older clients created on the tool
              this.selectedClient.clientProfile.spousePension = spouse.pension;
            }

            this.riskToleranceEnabled = JSON.parse(localStorage.getItem('featRiskTolerance'));
            
            this.selectedClient.clientProfile.spouseRetirementState  = spouse.state;
            this.selectedClient.clientProfile.spouseLifeExpectancy = spouse.LifeExpectancy;
          }
        });
        

        localStorage.setItem('selectedClient', userID.toString())

        if (this.role == 1 || this.role == 2) {
          localStorage.setItem('selectedAdvisor', client.advisor.FirstName + " " + client.advisor.LastName);
          localStorage.setItem('selectedAdvisorID', client.advisor.ID);
          localStorage.setItem('selectedAdvisorOrgID', client.advisor.OrganizationID);
          this.advisorBarService.refresh();
        }

      },
      error => this.error = <any>error);
  }

  createReport(reportUrl) {
    if (reportUrl == 'hcam' || reportUrl == 'ltcam') {
      this.router.navigate(['../reports/create/', reportUrl.replace('am','')], { queryParams: { am: 1 } });
    } else {
      this.router.navigate(['../reports/create/', reportUrl]);
    }
  }

  selectClient(client, clientSearch) {
    clientSearch.value = client.spouseName ? client.FirstName + " " + client.LastName + " and " + client.spouseName : client.FirstName + " " + client.LastName;
    this.getClient(client.ID);
    this.getClientReports(client.ID);
    this.filteredClients = [];
  }

  handleEditClientModal(e, client) {
    this.modalService.add('add-edit-client', { ID: localStorage.getItem('selectedClient') });
  }

  downloadReport(e, report, client) {
    this.loadingService.isLoading(true);

    var reportID = report.reportID;
    var advisorID = report.advisorID;
    var clientID = client.ID;
    var orgID = client.OrganizationID;

    // var clientID = client.ID;
    // var orgID = client.OrganizationID;

    var reportTypeID = report.reportTypeID;

    var spouse = JSON.parse(this.selectedClient.clientProfile.Spouses)[0];

    var ReportFields = { reportID, advisorID, clientID, orgID, reportTypeID, token: localStorage.getItem("bearer"), retirementAge: this.selectedClient.clientProfile.RetirementAge, spouseRetirementAge: Number(spouse.retirementAge) || 0 };

    this.globalService.generateReport(ReportFields, client, report)
      .subscribe(
      resp => {
        this.loadingService.isLoading(false);
      },
      error => {
        this.error = <any>error;
        this.loadingService.isLoading(false);
      });
  }

  calculateAge(birthday) {
    birthday = new Date(birthday);
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  formatReportTypeID(ReportTypeID: number) {
    return Utils.formatReportTypeID(ReportTypeID, this.globalService.featRiskTolerance);
  }

  // convertMaritalStatus() {
  //   var maritalStatusID = this.selectedClient.clientProfile.maritalStatus;
  //   return maritalStatusID === 1 ? "Single" : maritalStatusID === 2 ? "Married"
  // }

  formatDate(date) {
    date = new Date(date);
    return date > 1/1/1900 ? (date.getMonth() + 1) + '/' + date.getDate() + '/' +  date.getFullYear() + ' ' + Utils.parseDateTime(date) : '--';
  }

  setPage(page: number) {
    if (!this.reports.length) {
      this.pager = [];
      this.pagedItems = [];
      return;
    }

    if (page < 1 || page > this.pager.totalPages) {
      return;
    }

    // get pager object from service
    this.pager = this.pagerService.getPager(this.reports.length, page);

    // get current page of items
    this.pagedItems = this.reports.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }
}


